module.exports = __webpack_public_path__ + "static/media/edit_prescription.ab12de3c.svg";